import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidUkIcon,
  IphoneUkIcon,
  GameUkIcon,
  FlutterIcon,
  HealthcareUkIcon,
  ReactUkIcon,
} from "../../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidUkIcon,
    title: "Android Game Development",
    description: (
      <>
        TekRevol is one of your go-to game development companies in London that
        specializes in offering top-notch Android app development services. As
        one of the premium UK game studios, we bring your gaming ideas to life,
        tailoring them to fit seamlessly into the Android ecosystem. With
        expertise in Android's technical complexities, our dedicated team
        ensures a smooth and engaging user experience. Join us on the journey of
        creating immersive Android gaming experiences that redefine the
        standards of excellence in the dynamic world of{" "}
        <Link
          to="https://www.tekrevol.com/uk/mobile-app-development-company-uk"
          rel="noopener"
          aria-label="TekRevol"
        >
          mobile app development.
        </Link>{" "}
      </>
    ),
  },
  {
    icon: IphoneUkIcon,
    title: "iPhone Game Development",
    description:
      "As a leading game development agency in London, TekRevol utilizes cutting-edge technology and technical prowess to bring your gaming visions to life on iOS devices. The iPhone app development services that we offer deliver seamless and captivating user experiences, which makes us stand out as a leader for iOS game development in UK. Collaborate with the best UK game developers from TekRevol to create tailored and innovative games that set new benchmarks in the domain of iPhone games.",
  },
  {
    icon: GameUkIcon,
    title: "Web Game Development",
    description: (
      <>
        "TekRevol is a pioneer among gaming companies in London, with a team
        that combines technical expertise and creative innovation to craft
        captivating games accessible directly from your web browser. As one of
        the bespoke game studios in the UK, we leverage advanced technologies to
        ensure a seamless and immersive gaming experience. In addition to our
        gaming prowess, we also offer comprehensive{" "}
        <Link to="https://www.tekrevol.com/uk/web-development-company-uk">
          web development services
        </Link>
        , creating dynamic and responsive websites that enhance user engagement
        and drive business growth."
      </>
    ),
  },
  {
    icon: FlutterIcon,
    title: "AR/VR Game Development",
    description:
      "As leading UK-based game developers, TekRevol specializes in the cutting-edge domain of AR/VR game development, where reality meets innovation. Our expert team leverages advanced technologies to create captivating and lifelike gaming experiences that push the boundaries of what's possible. With a focus on seamless interactivity and immersive storytelling, TekRevol transforms your gaming ideas into virtual realities that captivate audiences.",
  },
  {
    icon: HealthcareUkIcon,
    title: "NFT Game Development ",
    description:
      "TekRevol is among the top game developer companies in UK that creates unique and immersive gaming experiences through the integration of Non-Fungible Tokens (NFTs). As a top-grade mobile game development company, our expert team combines technical skills with creative innovation to bring your gaming ideas to life on the blockchain, offering players unprecedented ownership of in-game assets. Collaborate with the top-grade UK game developers from TekRevol to transform your business and set new benchmarks for excellence in NFT game development.",
  },
  {
    icon: ReactUkIcon,
    title: "HTML Game Developmet",
    description:
      "As a leading mobile game development company in UK, TekRevol utilizes HTML to craft immersive gaming experiences that seamlessly integrate with devices. Focusing on cutting-edge technology and user-centric design, we bring your gaming concepts to life, ensuring optimal performance and engagement. Join us at the forefront of technological advancements and elevate your gaming ideas with TekRevol.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              Services TekRevol Offers as a Versatile Game Development Company
              in UK
            </h2>
            <p className="impro_para">
              TekRevol stands out among game development companies in UK by
              offering a diverse range of services that cater to the dynamic
              needs of the industry. As one of the top mobile game developers in
              UK, we redefine the gaming world by creating creative and flexible
              solutions. Here are the mobile game development services in UK
              that TekRevol offers:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
